import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import styles from './ViewJobQuotes.module.css'; // We'll create this next
import Loader2 from '../../components/loader2';
import showToast from '../../components/ShowToast';
import { jwtDecode } from 'jwt-decode'; // To get homeUserId for messaging (if needed)
import api from '../../api/api.js';

// --- MODIFICATION 1: IMPORT THE BUSINESS PROFILE PANEL ---
import BusinessProfilePureCSS from '../../profiles/BusinessProfilePureCSS';

import { 
  ArrowLeft, 
  MessageSquare, 
  CheckCircle, 
  AlertTriangle, 
  Info, 
  X,
  Star,
  CalendarDays,
  DollarSignIcon,
  Briefcase // For business icon
} from 'lucide-react';

// Helper to format date (can be moved to a utils file)
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return new Date(dateString).toLocaleDateString('en-AU', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch (e) {
    return 'Invalid Date';
  }
};

const ViewJobQuotes = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const [quotes, setQuotes] = useState([]);
  const [jobDetails, setJobDetails] = useState(null); // To store job name
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [selectedQuote, setSelectedQuote] = useState(null); // For modal
  const [isQuoteDetailModalOpen, setIsQuoteDetailModalOpen] = useState(false);
  const [isAssignConfirmModalOpen, setIsAssignConfirmModalOpen] = useState(false);
  const [quoteToAssign, setQuoteToAssign] = useState(null);
  const [isAssigning, setIsAssigning] = useState(false);

  const [homeUserId, setHomeUserId] = useState(null);

  // --- MODIFICATION 2: ADD STATE FOR THE BUSINESS PROFILE PANEL ---
  const [isBusinessProfileOpen, setIsBusinessProfileOpen] = useState(false);
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);


  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decoded = jwtDecode(token);
      setHomeUserId(decoded.nameid); // Assuming nameid is the user's ID
    }
  }, []);

  const fetchQuotesAndJobDetails = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      // Fetch job details (primarily for job name, and to verify job exists)
      const jobDetailResponse = await axios.get(`${API_BASE_URL}/api/Jobs/getjobbyid?id=${jobId}`);
      setJobDetails(jobDetailResponse.data);

      // Fetch quotes for the job
      // Endpoint based on Flutter code: /api/Jobs/quote/{jobId}
      const quotesResponse = await axios.get(`${API_BASE_URL}/api/Jobs/quote/${jobId}`);
      setQuotes(quotesResponse.data || []);

    } catch (err) {
      console.error("Error fetching quotes or job details:", err);
      setError(err.message || "Failed to load data.");
      showToast('error', `Error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  }, [jobId]);



  // --- MODIFICATION 3: ADD HANDLERS FOR THE BUSINESS PROFILE PANEL ---
  const openBusinessProfile = (businessId) => {
    setSelectedBusinessId(businessId);
    setIsBusinessProfileOpen(true);
  };

  const closeBusinessProfile = () => {
    setIsBusinessProfileOpen(false);
    setSelectedBusinessId(null);
  };



  useEffect(() => {
    fetchQuotesAndJobDetails();
  }, [fetchQuotesAndJobDetails]);

  const openQuoteDetailModal = (quote) => {
    setSelectedQuote(quote);
    setIsQuoteDetailModalOpen(true);
  };

  const closeQuoteDetailModal = () => {
    setSelectedQuote(null);
    setIsQuoteDetailModalOpen(false);
  };

  const handleAssignJob = (quote) => {
    setQuoteToAssign(quote);
    setIsAssignConfirmModalOpen(true);
  };

  const confirmAssignJob = async () => {
    if (!quoteToAssign || !quoteToAssign.business?.businessId) {
      showToast('error', 'Business details are missing for this quote.');
      return;
    }
    setIsAssigning(true);
    try {
      // API: POST /api/Jobs/{jobId}/hire/{businessId}
      await axios.post(`${API_BASE_URL}/api/Jobs/${jobId}/hire/${quoteToAssign.business.businessId}`);
      showToast('success', `Job assigned to ${quoteToAssign.business.businessName}!`);
      setIsAssignConfirmModalOpen(false);
      setQuoteToAssign(null);
      // Optionally, refresh quotes or navigate away
      fetchQuotesAndJobDetails(); // Re-fetch to update status or assigned business
      navigate(`/job-detail-new/${jobId}`); // Or back to dashboard
    } catch (err) {
      console.error("Error assigning job:", err);
      showToast('error', `Failed to assign job: ${err.response?.data?.message || err.message}`);
    } finally {
      setIsAssigning(false);
    }
  };
  
  const handleMessageBusiness = (quote) => {
    // Placeholder for navigation to messaging screen
    // Example: navigate(`/messages/job/${jobId}/business/${quote.businessUserId}`);
    // Need to ensure homeUserId and businessUserId are correctly passed
    // For now, just a toast.

    console.log(quote);

    if (!homeUserId || !quote.businessUserId) {
        showToast('error', 'User or business ID missing for messaging.');
        return;
    }
    showToast('info', `Messaging with ${quote.business?.businessName} (Job: ${jobId}, Business: ${quote.businessUserId}, HomeUser: ${homeUserId}) - Not Implemented`);
  };


    const handleMessageClickConcise = async (quote) => {
        //setLoading(true);
        try {
    
            //console.log(`otherUser.businessId = ${otherUser.businessId}`);
            //console.log(`otherUser.businessUserId = ${otherUser.businessUserId}`);
    
    
            // 1. Grab your auth token, decode it:
            const token = localStorage.getItem('token');
            if (!token) {
            navigate('/login');
            return;
            }
            const { nameid: currentUserId, UserType } = jwtDecode(token);


            const myuserType = localStorage.getItem('userType');
            let url = "";


            // 2. Build the three query params that NewConversation expects:
            //    - always need senderBusinessUserId
            //    - supply either homeUserId OR receiverBusinessUserId
            const isHome = myuserType === 'Home';

            const senderBusinessUserId = isHome
            ? quote.businessuserid    // if I'm a Home‐user, I pass the Business I'm talking to
            : currentUserId;              // otherwise I (a Business) pass my own ID
    
            const homeUserId = isHome
            ? currentUserId               // Home user passes themselves
            : undefined;
    
            const receiverBusinessUserId = !isHome
            ? quote.businessuserid   // Business talking to another Business
            : undefined;
    
            console.log(`currentUserId = ${currentUserId}`);
            console.log(`senderBusinessUserId = ${senderBusinessUserId}`);
            console.log(`receiverBusinessUserId = ${receiverBusinessUserId}`);
            console.log(`homeUserId = ${homeUserId}`);
    
    
            // 3. Assemble and call the NewConversation endpoint:
            //senderBusinessUserId=123&homeUserId=456

            if (myuserType == "Home")
            {
                url = `senderBusinessUserId=${senderBusinessUserId}&homeUserId=${homeUserId}`;
            }
            else
            {
                url = `senderBusinessUserId=${senderBusinessUserId}&receiverBusinessUserId=${receiverBusinessUserId}`;                
            }

            const { data } = await api.get(
            `/api/Chat/NewConversation?${url}`
            );
    
            // 4. Pull out the conversationId and open the right route in a new tab
            const { conversationId } = data;
            const path = isHome
            ? `/home_messages?conversationId=${conversationId}`
            : `/business_messages?conversationId=${conversationId}`;
    
            window.open(path, '_blank', 'noopener,noreferrer');
        } catch (err) {
            console.error('Error starting conversation:', err);
        } finally {
            //setLoading(false);
        }
    };





  if (isLoading) return <Loader2 />;
  if (error) return <div className={styles.errorState}>Error: {error} <button onClick={fetchQuotesAndJobDetails}>Try Again</button></div>;

  return (

    <>

    <div className={styles.pageContainer}>
      <header className={styles.header}>
        <button onClick={() => navigate(-1)} className={styles.backButton}>
          <ArrowLeft size={24} />
        </button>
        <h1>Quotes for: {jobDetails?.name || `Job ID ${jobId}`}</h1>
      </header>

      <main className={styles.mainContent}>
        {quotes.length === 0 ? (
          <div className={styles.emptyState}>
            <MessageSquare size={48} className={styles.emptyIcon} />
            <p>No quotes received for this job yet.</p>
          </div>
        ) : (
          <ul className={styles.quoteList}>
            {quotes.map((quote) => (
              <li key={quote.quoteId || quote.id} className={styles.quoteListItem} onClick={() => openQuoteDetailModal(quote)}>
                <div className={styles.quoteBusinessInfo}>
                  {quote.business?.profilePic ? (
                    <img src={quote.business.profilePic} alt={quote.business.businessName} className={styles.businessLogo} />
                  ) : (
                    <div className={styles.businessLogoPlaceholder}><Briefcase size={24}/></div>
                  )}
                  <div>
                    <h3 className={styles.businessName}>{quote.business?.businessName || 'Unknown Business'}</h3>
                    <p className={styles.quoteDate}>Quoted on: {formatDate(quote.created_at)}</p>
                  </div>
                </div>
                <div className={styles.quotePrice}>
                  {quote.price != null ? `$${Number(quote.price).toFixed(2)}` : 'Price N/A'}
                </div>
              </li>
            ))}
          </ul>
        )}
      </main>

{isQuoteDetailModalOpen && selectedQuote && (
    <div className={styles.modalBackdrop} onClick={closeQuoteDetailModal}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button onClick={closeQuoteDetailModal} className={styles.modalCloseButton}><X size={20} /></button>
        
        <h2>{selectedQuote.business?.businessName}</h2>
        
        <div className={styles.detailGrid}>
            <div className={styles.detailItem}>
                <span className={styles.detailLabel}><DollarSignIcon size={14}/> Price</span>
                <span className={`${styles.detailValue} ${styles.priceValue}`}>${Number(selectedQuote.price).toFixed(2)}</span>
            </div>
            
            <div className={styles.detailItem}>
                <span className={styles.detailLabel}><CalendarDays size={14}/> Quoted On</span>
                <span className={styles.detailValue}>{formatDate(selectedQuote.created_at)}</span>
            </div>

            {selectedQuote.business?.overallRating != null && (
               <div className={styles.detailItem}>
                  <span className={styles.detailLabel}><Star size={14}/> Rating</span>
                  <span className={styles.detailValue}>{Number(selectedQuote.business.overallRating).toFixed(1)} / 5.0</span>
               </div>
            )}
        </div>

        <div className={styles.detailSectionTitle}>Message from Business:</div>
        <div className={styles.quoteMessage}>{selectedQuote.message || 'No specific message provided.'}</div>
        
        <div className={styles.modalActions}>
          <button 
            onClick={() => handleMessageClickConcise(selectedQuote)} 
            className={`${styles.actionButton} ${styles.messageButton}`}
          >
            <MessageSquare size={18} /> Message
          </button>
          <button 
            onClick={() => handleAssignJob(selectedQuote)} 
            className={`${styles.actionButton} ${styles.assignButton}`}
            disabled={jobDetails?.jobStatus === 'Assigned' || jobDetails?.jobStatus === 'Complete'} 
          >
            <CheckCircle size={18} /> Assign Job
          </button>
        </div>
        
        {selectedQuote.business?.businessId && (
            <button 
                onClick={() => openBusinessProfile(selectedQuote.business.businessId)} 
                className={styles.profileLink}
            >
                View full profile for {selectedQuote.business.businessName}
            </button>
        )}
      </div>
    </div>
)}

      {isAssignConfirmModalOpen && quoteToAssign && (
        <div className={styles.modalBackdrop} onClick={() => setIsAssignConfirmModalOpen(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setIsAssignConfirmModalOpen(false)} className={styles.modalCloseButton}><X size={20} /></button>
            <h3>Confirm Assignment</h3>
            <p>
              Are you sure you want to assign this job to <strong>{quoteToAssign.business?.businessName}</strong> for 
              <strong> ${Number(quoteToAssign.price).toFixed(2)}</strong>?
            </p>
            <div className={styles.modalActions}>
              <button onClick={() => setIsAssignConfirmModalOpen(false)} className={`${styles.actionButton} ${styles.cancelButton}`}>
                Cancel
              </button>
              <button onClick={confirmAssignJob} className={`${styles.actionButton} ${styles.confirmAssignButton}`} disabled={isAssigning}>
                {isAssigning ? <Loader2 size="sm" /> : 'Confirm & Assign'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

      {/* --- MODIFICATION 5: RENDER THE BUSINESS PROFILE PANEL --- */}
      <BusinessProfilePureCSS
        isOpen={isBusinessProfileOpen}
        onClose={closeBusinessProfile}
        businessId={selectedBusinessId}
        useIDTYPE={"BID"}
      />

</>


  );
};

export default ViewJobQuotes;
